import $ from 'jquery';
import { clearAllBodyScrollLocks } from 'body-scroll-lock';
import { loadContent } from '../util/fetchutils';
import { onEvent } from '../util/domutils'; // eslint-disable-line import/named
import convertSizes from '../components/sizeConversions';
import initAttributes from './components/attributes';
import handleCarousel from './components/imageCarousel';

import base from './base';

const SELECTORS = {
  MODAL: '#quickViewModal',
};

const handlePageElements = () => {
  initAttributes();
  handleCarousel(true);
};

base.showQuickview = function () {
  onEvent(document, 'click', 'p.quickview', async (e) => {
    e.preventDefault();

    const { content } = await loadContent(e.delegateTarget);
    const existingModal = document.querySelector(SELECTORS.MODAL);

    if (existingModal) {
      existingModal.remove();
    }

    document.body.insertAdjacentHTML('beforeend', content);

    $(SELECTORS.MODAL).on('shown.bs.modal', convertSizes);
    $(SELECTORS.MODAL).on('shown.bs.modal', handlePageElements);
    $(SELECTORS.MODAL).modal('show');
  });
};

base.showbackInStock = function () {
  onEvent(document, 'click', 'a.continuity-flyout__button--toggle', () => {
    // eslint-disable-next-line jquery/no-animate
    $('.modal-open .modal').animate({
      scrollTop: 0,
    }, 0);
  });
};

base.showSizeChart = function () {
  onEvent(document, 'click', 'a.size-chart', () => {
    // eslint-disable-next-line jquery/no-animate
    $('.modal-open .modal').animate({
      scrollTop: 0,
    }, 0);
  });
};

base.pageBehavior = () => {
  document.addEventListener('product:afterAttributeSelect', handlePageElements);
};

base.hideDialog = () => {
  $(document.body).on('product:afterAddToCart', (e, data) => {
    if (data && !data.error && !data.attributeErrors) {
      $(SELECTORS.MODAL).modal('hide');
    }
  });
  onEvent(document, 'click', '.quick-view-dialog .close', () => {
    clearAllBodyScrollLocks();
  });
};

export default base;
